import { handleActions } from 'redux-actions';
import { sum } from 'lodash-es';

import {
  SuitableForValue,
  SuitableForFilterCount,
} from 'ha/types/SearchFilters';

import { SuitableForFilterState } from './Types';
import { Actions } from '../constants';

const initialState = {
  listingCount: {},
  value: [],
  isHidden: false,
};

interface Payload {
  filtersCount: {
    suitableFor: SuitableForFilterCount;
  };
  globalFiltersCount: {
    suitableFor: SuitableForFilterCount;
  };
  suitableFor: SuitableForValue;
}

export default handleActions<SuitableForFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.suitableFor,
      isHidden:
        sum(Object.values(payload.globalFiltersCount.suitableFor)) === 0,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { suitableFor = [] } },
    ) => ({
      ...state,
      value: Array.isArray(suitableFor) ? suitableFor : [suitableFor],
    }),
  },
  initialState,
);

export const getSuitableForFilter = (state: SuitableForFilterState) =>
  state.value;
